module.exports = __webpack_public_path__ + "img/hardwaretest-done.97cf272a.png";